import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('entry');

  useEffect(() => {
    const sections = navLinks
      .map((link) => document.getElementById(link.id))
      .filter((el): el is HTMLElement => Boolean(el));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <nav className="mx-auto flex max-w-[1280px] items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-fire-line text-lg" aria-hidden="true" />
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">爆料网</span>
          <span className="hidden text-xs text-foreground-500 sm:inline">入口导航站</span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`rounded-md px-3 py-2 text-sm transition-colors ${
                active === link.id
                  ? 'bg-primary-100 font-medium text-primary-800'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#entry"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            前往入口
          </a>
          <button
            type="button"
            onClick={() => setOpen((value) => !value)}
            aria-label="展开导航菜单"
            aria-expanded={open}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto grid max-w-[1280px] grid-cols-2 gap-2 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}